import { render, staticRenderFns } from "./integralOrderList.vue?vue&type=template&id=04234782&scoped=true&"
import script from "./integralOrderList.vue?vue&type=script&lang=js&"
export * from "./integralOrderList.vue?vue&type=script&lang=js&"
import style0 from "./integralOrderList.vue?vue&type=style&index=0&id=04234782&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04234782",
  null
  
)

export default component.exports